angular.module('impactx.tender').controller('TenderListCtrl',
    ['selectedListItems', 'dataGen', '$route', 'ToastService', 'ConfirmationService', TenderListCtrl]);

function TenderListCtrl(selectedListItems, dataGen, $route, ToastService, ConfirmationService)
{
    var ctrl = this;

    this.getDetailLink = function() {
        return "tenderdetail/" + selectedListItems.getFirstSelectedId();
    };

    this.getTenderLotCSCLink = function() {
        return "tenderlotcsclist/" + selectedListItems.getFirstSelectedId();
    };

    this.getLotLink = function() {
        return "lotlist/tender/" + selectedListItems.getFirstSelectedId();
    };

    this.getCSCLink = function() {
        return "cscontractlist/tender/" + selectedListItems.getFirstSelectedId();
    };

    this.getEditClosedCalendarLink = function() {
        return "closedcalendar/0/" + selectedListItems.getFirstSelectedId();
    };

    this.canDelete = function() {
        if (!selectedListItems.isMultiSelection())
        {
            return false;
        }
        else
        {
            var items = selectedListItems.getSelectedItems();
            for (var i = 0; i < items.length; i++)
            {
                if (!items[i].canEdit.value)
                {
                    return false;
                }
            }
            return true;
        }
    };

    this.deleteDialog = function(event, trns) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, trns.confirmDelete,
            trns.delete, trns.abort);
    };

    this.delete = function() {
        var dataObj = {
            ids: selectedListItems.getSelectedIds()
        };
        var temp = {};
        dataGen.postAsForm(temp, dataObj, "/tender/deletemultiple").then(function() {
            $route.reload();
            ToastService.openStandardToast(temp.trns.deleteSuccess);
        });
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'ViewTenderDetail'},
        //{label: "tenderlotcscdetail", linkFunction: ctrl.getTenderLotCSCLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'ListTender'},
        {label: "lots", linkFunction: ctrl.getLotLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'ListLot'},
        {label: "contracts", linkFunction: ctrl.getCSCLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'CSContract'},
        {label: "closedCalendar", linkFunction: ctrl.getEditClosedCalendarLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'EditClosedCalendar'},
        {label: "delete", action: ctrl.deleteDialog, condition: ctrl.canDelete, process: 'EditTender'}];

    this.meta = {
        rowTemplate: 'modules/tender/templates/tenderlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/tender/list',
        id: "tenderlist",
        mainAction : {id:"new", link: "#/tenderdetail/0", icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}